
import { defineComponent } from "vue";
import ProductPriceLines from "@/views/ProductPriceLines.vue";

export default defineComponent({
  props: {
    productId: {
      type: Number,
      required: true,
    },
    dateStart: {
      type: String,
      required: false,
    },
    slotId: {
      type: Number,
      required: false,
    },
  },
  components: { ProductPriceLines },
  async setup() {
    return {
      ProductPriceLines,
    };
  },
});
